// test1124
(1124 && 0);
